const MemberPrimaryAttributes = {
    EMAIL: "EMAIL",
    MOBILE_NUMBER: "MOBILE_NUMBER",
};

export { MemberPrimaryAttributes};